/*
SHARED FILE

7 sites use this List module

*/
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { Element, scroller } from 'react-scroll'
import Loader from 'react-loader'
import config from '../../config'
import container from '../../helpers/container'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import {
  ContainerDivs,
  IyvListTutorial,
  IyvListSearchBar,
  IyvListSearchSettingsButton,
  IyvListFilters,
  IyvListTutorialRestartButton,
  IyvListActiveFilters,
  IyvListTable,
  IyvListMobileTable,
  IyvListViewPanelTabs,
  IyvListGetMoreFundsButton,
  IyvListCart,
  // YesNo,
  // Grade,
  // GenderEqualityScoreLabel,
  // Link,
  LinkIcon,
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './List.css'
// require('react-select/dist/react-select.css')


/*
 * GLOBALS
 *
 */
// columns to show when viewPanel==='results' vs. 'performance'
// for each view panel, 2d array where each column is [Label, field]
const PerformanceColumns = [
  ['Fund name', 'name'],
  ['Expense ratio', 'prospectus_net_expense_ratio'],
  ['1-year', 'trailing_return_y1'],
  ['3-year', 'trailing_return_y3'],
  ['5-year', 'trailing_return_y5'],
  ['10-year', 'trailing_return_y10'],
  ['15-year', 'trailing_return_y15'],
  ['20-year', 'trailing_return_y20'],
]
const IyvColumns = [
  // ['Sustainability mandate', 'ussif'],
  ['Fossil fuels', 'grade_fossil'],
  // ['Fossil finance grade', 'fossil_bank_score'],
  // ['Fossil insurance grade', 'fossil_insure_score'],
  ['Deforestation', 'grade_deforestation'],
  ['Gender Equality', 'grade_gender_equality'],
  ['Diversity Disclosures', 'grade_dei'],
  ['Racial Justice', 'grade_rji'],
  ['LGBTQ+ Equity', 'grade_hrc'],
  ['Guns', 'grade_guns'],
  ['Prison & Borders  ', 'grade_prison_industrial_complex'],
  ['Military weapons', 'grade_military'],
  ['Tobacco', 'grade_tobacco'],
]
const ResultsTableColumns = {
  'Invest Your Values' : {
    results : [['Fund name', 'name']].concat(IyvColumns),
    // performance : PerformanceColumns.concat([
    //   ['Net assets', 'fund_net_assets'],
    //   ['Group', 'category_group'],
    // ]),
  },
  'Gun Free Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Civilian firearms grade', 'grade_guns'],
      ['Sustainability mandate', 'ussif'],
      ['Gun makers', 'gm_weight'],
      ['Gun retailers', 'gr_weight'],
      ['Gun makers + retailers', 'wff_civ_weight'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Civilian firearms grade', 'grade_guns']]
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Tobacco Free Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Tobacco grade', 'grade_tobacco'],
      ['Sustainability mandate', 'ussif'],
      ['Tobacco companies', 'to_weight'],
      ['Tobacco-promoting studios', 'tm_weight'],
      ['Tobacco companies + studios', 't_all_weight'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Tobacco grade', 'grade_tobacco']]
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Deforestation Free Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Deforestation grade', 'grade_deforestation'],
      ['Sustainability mandate', 'ussif'],
      ['Commodity producers', 'po_producer_weight'],
      ['Banks + lenders', 'po_financier_weight'],
      ['Consumer brands', 'po_consumer_weight'],
      ['Total deforestation risk exposure', 'po_all_weight'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Deforestation grade', 'grade_deforestation']],
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Weapon Free Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Military weapons grade', 'grade_military'],
      ['Sustainability mandate', 'ussif'],
      ['Top 100 military contractors', 'mmc_weight'],
      ['Cluster munitions', 'cm_weight'],
      ['Nuclear weapons', 'nw_weight'],
      ['All military weapons exposure', 'wff_mil_weight'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Military weapons grade', 'grade_military']],
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Fossil Free Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Fossil fuels', 'c2f5coogutweight'],
      ['Sustainability mandate', 'ussif'],
      // ['Fossil fuels', 'c2f5coogutweight'],
      // ['Carbon footprint', 'usd_relative_footprint'],
      ['Fossil finance', 'fossil_bank_score'],
      ['Fossil insurance', 'fossil_insure_score'],
      ['Clean200', 'cl_weight'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Fossil fuels', 'grade_fossil']],
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Gender Equality Funds' : {
    results : [
      ['Fund name', 'name'],
      ['Gender equality grade', 'grade_gender_equality'],
      ['Gender equality rank, by group', 'gef_grp_norm'],
      ['Gender equality score', 'gef_score'],
      ['Sustainability mandate', 'ussif'],
      ['Net assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Gender equality grade', 'grade_gender_equality']],
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Social Justice Funds' : {
    results : [
      ['Name', 'name'],
      ['Sustainability Mandate', 'ussif'],
      ['Net Assets', 'fund_net_assets'],

      ['Gender Equality', 'grade_gender_equality'],
      // ['Gender equality rank, by group', 'gef_grp_norm'],
      // ['Gender equality score', 'gef_score'],

      ['Diversity Disclosures', 'grade_dei'],
      // ['Diversity disclosures rank, by group', 'dei_grp_norm'],
      // ['Diversity disclosures score', 'dei_score'],

      ['Racial Justice', 'grade_rji'],
      // ['Racial justice rank, by group', 'rji_grp_norm'],
      // ['Racial justice score', 'rji_score'],

      ['LGBTQ+ Equity', 'grade_hrc'],
      // ['LGBTQ+ equity rank, by group', 'hrc_grp_norm'],
      // ['LGBTQ+ equity score', 'hrc_score'],

      ['Prison & Borders', 'grade_prison_industrial_complex'],
      ['Military Weapons', 'grade_military'],

      // ['Group', 'category_group'],
    ],
    gef: [
      ['Name', 'name'],
      ['Sustainability Mandate', 'ussif'],
      ['Gender Equality', 'grade_gender_equality'],
      ['Gender equality rank, by group', 'gef_grp_norm'],
      ['Gender equality score', 'gef_score'],
      ['Net Assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    dei: [
      ['Name', 'name'],
      ['Sustainability Mandate', 'ussif'],
      ['Diversity disclosures', 'grade_dei'],
      ['Diversity disclosures rank, by group', 'dei_grp_norm'],
      ['Diversity disclosures score', 'dei_score'],
      ['Net Assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    rji: [
      ['Name', 'name'],
      ['Sustainability Mandate', 'ussif'],
      ['Racial Justice', 'grade_rji'],
      ['Racial justice rank, by group', 'rji_grp_norm'],
      ['Racial justice score', 'rji_score'],
      ['Net Assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    hrc: [
      ['Name', 'name'],
      ['Sustainability Mandate', 'ussif'],
      ['LGBTQ+ Equity', 'grade_hrc'],
      ['LGBTQ+ equity rank, by group', 'hrc_grp_norm'],
      ['LGBTQ+ equity score', 'hrc_score'],
      ['Net Assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns,
    // .concat(
    //   [['Gender equality grade', 'grade_gender_equality']],
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
  'Prison Free Funds' : {
    results : [
      ['Fund Name', 'name'],
      ['Prison Industrial Complex Grade', 'grade_prison_industrial_complex'],
      ['Sustainability Mandate', 'ussif'],
      ['All Flagged', 'pff_all_weight'],
      ['High Risk', 'pff_all_high_weight'],
      ['High Risk: Prisons', 'pp_high_weight'],
      ['High Risk: Borders', 'borders_high_weight'],
      ['High Risk: Private Prisons', 'pff_all_extreme_weight'],
      ['Net Assets', 'fund_net_assets'],
      ['Group', 'category_group'],
    ],
    // performance : PerformanceColumns.concat(
    //   [['Prison industrial complex grade', 'grade_prison_industrial_complex']]
    // ),
    iyv : [['Fund name', 'name']].concat(IyvColumns)
  },
}


const DefaultFilter = 'All funds'

const MarketOptionsFilters = [
  'fundFamily', 'currency', 'fundGroup' // 'fundCategory',  
]


// GEF
const DEFAULT_GROUP_TYPE = 'group'

let Filters = [
  { order:0, label:'Fund family', state:'fundFamily', prop:'ff' },
  { order:0, label:'Fund group', state:'fundGroup', prop:'grp' },
  // { order:0, label:'Fund category', state:'fundCategory', prop:'fdc' },
  // {
  //   order:0,
  //   label:'Financial performance',
  //   state:'fundPerformance',
  //   prop:'perf'
  // },

  { order:1, label:'Fund type', state:'type', prop:'typ'},

  // { order:1, label:'Diversified', state:'diversified', prop:'div' },
  { order:1, label:'Target date', state:'targetDate', prop:'td'},

  { order:1, label:'Sustainability mandate', state:'sri', prop:'sri' },
  // {
  //   order:1,
  //   label:'Forum for Sustainable and Responsible Investment (US-SIF)',
  //   state:'fundUssif',
  //   prop:'usf'
  // },
]
const DefaultGradeFilters = [
  { order:2, label:'Fossil fuel grade', state:'fffGrade', prop:'fffgrd' },
  { order:2, label:'Fossil finance grade', state:'ffbGrade', prop:'ffbgrd' },
  { order:2, label:'Fossil insurance grade', state:'ffiGrade', prop:'ffigrd' },
  { order:2, label:'Deforestation grade', state:'dffGrade', prop:'dffgrd' },
  { order:2, label:'Weapon grade', state:'wffGrade', prop:'wffgrd' },
  { order:2, label:'Prison industrial complex grade', state:'pffGrade', prop:'pffgrd' },
  { order:3, label:'Civilian firearm grade', state:'gffGrade', prop:'gffgrd' },
  { order:3, label:'Tobacco grade', state:'tffGrade', prop:'tffgrd' },
  { order:3, label:'Gender equality grade', state:'gefGrade', prop:'gefgrd' },
  { order:3, label:'Racial justice grade', state:'rjiGrade', prop:'rjigrd' },
  { order:3, label:'Diversity disclosures grade', state:'deiGrade', prop:'deigrd' },
  { order:3, label:'LGBTQ+ equity grade', state:'hrcGrade', prop:'hrcgrd' },
]
const SjfGradeFilters = [
  { order:2, label:'Fossil fuel grade', state:'fffGrade', prop:'fffgrd' },
  { order:2, label:'Fossil finance grade', state:'ffbGrade', prop:'ffbgrd' },
  { order:2, label:'Fossil insurance grade', state:'ffiGrade', prop:'ffigrd' },
  { order:2, label:'Deforestation grade', state:'dffGrade', prop:'dffgrd' },
  { order:2, label:'Weapon grade', state:'wffGrade', prop:'wffgrd' },
  { order:2, label:'Prison industrial complex grade', state:'pffGrade', prop:'pffgrd' },
  { order:3, label:'Civilian firearm grade', state:'gffGrade', prop:'gffgrd' },
  { order:3, label:'Tobacco grade', state:'tffGrade', prop:'tffgrd' },
  { order:3, label:'Gender equality grade', state:'gefGrade', prop:'gefgrd' },
  { order:3, label:'Racial justice grade', state:'rjiGrade', prop:'rjigrd' },
  { order:3, label:'Diversity disclosures grade', state:'deiGrade', prop:'deigrd' },
  { order:3, label:'LGBTQ+ equity grade', state:'hrcGrade', prop:'hrcgrd' },
]
if (config.app.title === 'Social Justice Funds') {
  Filters = [...Filters, ...SjfGradeFilters]
} else {
  Filters = [...Filters, ...DefaultGradeFilters]
}


const propStateMap = [
  {
    state:'searchQuery',
    prop:'q',
    transform: (value) => {
      value = value.trim()
      return value === '' ?
        (null) :
        value
    }
  },
  { state:'page', prop:'pg', transform: (value) => parseInt(value,10) },
  { state:'sort', prop:'srt', transform: (value) => value },
  {
    state:'isDesc',
    prop:'dsc',
    transform: (value) => convert.boolean(value)
  },
  // { state:'screen', prop:'screen', transform:(value)=>value },
]


/*
 * STATE MANAGEMENT VIA PROPS
 *
 */
const propsFromState = (state) => {
  /*
   * convert state to query props
   */
  const props = {}

  propStateMap.forEach((map) => {
    // in map
    if (
      typeof state[map.state] !== 'undefined' &&
      state[map.state] !== null
    ) {
      // has value after transform
      const value = map.transform(state[map.state])

      if (typeof value !== 'undefined' && value !== null) {
        props[map.prop] = value
      }
    }
  })

  Filters.forEach((filter) =>{
    if (state.selectedFilters[filter.state]) {
      const value = state.selectedFilters[filter.state]

      props[filter.prop] = value
    }
  })

  // clean up url remove pg=1
  if (props.pg === 1) {
    delete props.pg
  }

  // defaults to true
  if (props.dsc === true) {
    delete props.dsc
  }

  return props
}

const stateFromProps = (props) => {
  /*
   * convert query props to state
   */
  // defaults
  let state = {
    sort: 'ussif',
    isDesc : true,
    page: 1,
    searchQuery: '',
    selectedFilters: {},
    // screen: 'all',
    location: props.location
  }

  propStateMap.forEach((map) => {
    // in map
    if (props.location.query[map.prop]) {
      // has value after transform
      const value = map.transform(props.location.query[map.prop])

      if (typeof value !== 'undefined' && value !== null) {
        state[map.state] = value
      }
    }
  })

  Filters.forEach((filter) => {
    const value = props.location.query[filter.prop]
    if (value) {
      state.selectedFilters[filter.state] = value
    }
  })

  // set input to query
  state = Object.assign(state, {
    searchInput: state.searchQuery
  })

  // reset results if page === 1
  if (state.page === 1) {
    state = Object.assign(state, {
      funds:[],
      lastResult: null
    })
  }

  return state
}

/*
 *
 *
 *
 *
 *
 *
 * COMPONENTS
 */
@CSSModules(Styles, {allowMultiple:true})
class IyvListHeaderTitle extends Component {
  render() {
    return <div styleName='list-header-title-panel'>
      <ContainerDivs>
        <div styleName='title'>
          Mutual Funds & ETFs
        </div>
      </ContainerDivs>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListTableMobileWraps extends Component {
  static propTypes = {
    page: PropTypes.number,
    loading: PropTypes.bool,
    currentTutorial: PropTypes.number,
    showTutorial: PropTypes.bool,
    clickCloseTutorial: PropTypes.func,
    viewPanel: PropTypes.string,
    funds: PropTypes.array,
    sort: PropTypes.string,
    isDesc: PropTypes.bool,
    activeGrouping: PropTypes.string,
    clickShareclass: PropTypes.func,
    clickCompareSelect: PropTypes.func,
    clickColumnHeader: PropTypes.func,
    cart: PropTypes.object,
    lastResult: PropTypes.array,
    removeFilters: PropTypes.func,
    clickGetMoreFunds: PropTypes.func,
    setViewPanel: PropTypes.func,
    getCompareSelectStyles: PropTypes.func,
    resultsTableColumns: PropTypes.object
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    const loaderFn = () => {
      /* selectVisible = true when not mobile */
      /* selectVisible = false when mobile */
      return <Loader
        options={{scale: 0.70, top:'150px'}}
        loaded={this.props.page !== 1 || !this.props.loading}
      >
        <div styleName='hidden-xs hidden-sm'>
          <div
            styleName={
              this.props.currentTutorial===1 && this.props.showTutorial ?
                'table-scroll tutorial-highlight-table' :
                'table-scroll'
            }
            onClick={this.props.clickCloseTutorial}
          >

            { /* core/IyvListTable/IyvListViewPanelTabs */ }
            <IyvListViewPanelTabs
              viewPanel={this.props.viewPanel}
              setViewPanel={this.props.setViewPanel}
            />

            { /* core/IyvListTable/IyvListTable */ }
            <IyvListTable
              viewPanel={this.props.viewPanel}
              funds={this.props.funds}
              selectVisible={true}
              sort={this.props.sort}
              isDesc={this.props.isDesc}
              activeGrouping={this.props.activeGrouping}
              clickShareclass={this.props.clickShareclass}
              clickCompareSelect={this.props.clickCompareSelect}
              clickColumnHeader={this.props.clickColumnHeader}
              cart={this.props.cart}
              getCompareSelectStyles={this.props.getCompareSelectStyles}
              resultsTableColumns={this.props.resultsTableColumns}
            />

          </div>
        </div>

        <div styleName='hidden-md hidden-lg'>

        { /* core/IyvListMobileTable/IyvListMobileTable */ }
          <IyvListMobileTable
            viewPanel={this.props.viewPanel}
            funds={this.props.funds}
            selectVisible={true}
            sort={this.props.sort}
            isDesc={this.props.isDesc}
            activeGrouping={this.props.activeGrouping}
            clickShareclass={this.props.clickShareclass}
            clickCompareSelect={this.props.clickCompareSelect}
            clickColumnHeader={this.props.clickColumnHeader}
            cart={this.props.cart}
            getCompareSelectStyles={this.props.getCompareSelectStyles}
            resultsTableColumns={this.props.resultsTableColumns}
          />

        </div>

        { /* core/IyvListTable/IyvListGetMoreFundsButton */ }
        <IyvListGetMoreFundsButton
          lastResult={this.props.lastResult}
          funds={this.props.lastResult}
          removeFilters={this.props.removeFilters}
          loading={this.props.loading}
          clickGetMoreFunds={this.props.clickGetMoreFunds}
        />

        { /* <IyvListSpreadsheetExport /> */ }

        { /* To reduce the effect of things moving around on the page
             when a reload is happening */
          this.props.loading ?
            <div style={{
              'height': '5000px',
              'width': '100%',
            }}/> :
            null
        }

      </Loader>
    }

    /* repeat this code 3 times to avoid animation issues with table */
    if (this.props.viewPanel==='results') {
      return loaderFn()
    } else if (this.props.viewPanel==='gef') {
      return loaderFn()
    } else if (this.props.viewPanel==='dei') {
      return loaderFn()
    } else if (this.props.viewPanel==='rji') {
      return loaderFn()
    } else if (this.props.viewPanel==='hrc') {
      return loaderFn()
    // } else if (this.props.viewPanel==='performance') {
    //   return loaderFn()
    } else if (this.props.viewPanel==='iyv') {
      return loaderFn()
    }

    return null
  }
}


@CSSModules(Styles, {allowMultiple:true})
class IyvListSpreadsheetExport extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
  }

  render() {
    return <div styleName='export-spreadsheet-wrap'>
      <div styleName='export-spreadsheet-txt'>
        You can also export the fund
        grades as an Excel file.
      </div>
      <div styleName='export-spreadsheet-link-wrap'>
        <button
          styleName='export-spreadsheet-btn'
          role='button'
          tabIndex='0'
          title={'Export spreadsheet'}
          onClick={
            () => { this.context.router.push(config.routes.howitworks+'#spreadsheet') }
          }
        >
          Download spreadsheet
          <LinkIcon faclass='fa-download'/>
          <LinkIcon faclass='fa-file-excel-o'/>
        </button>
      </div>
    </div>
  }
}


@connect(
  state => ({
    result: state.search.result,
    loading: state.search.loading,
    loaded: state.search.loaded,
    error: state.search.error,
    tutorialdismiss: state.tutorialdismiss.result,
    cart: state.cart.result,
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class List extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    search: PropTypes.func,
    tutorialdismiss: PropTypes.bool,
    cart: PropTypes.object
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }


  /*
   * COMPONENT SETUP
   *
   */
  constructor(props) {
    super(props)
    // const tutorialdismiss = this.props.tutorialdismiss
    let dflt = DEFAULT_GROUP_TYPE
    const initState = stateFromProps(props)
    switch (initState.sort) {
      case 'gef_peer_norm':
        dflt = 'peer'
        break
      case 'gef_rank':
        dflt = 'rank'
        break
      default:
        break
    }
    this.state = Object.assign(initState, {
      funds:[],
      lastResult: null,
      showTutorial: false, // !tutorialdismiss,
      currentTutorial: 0,
      showFilters: false,
      // showScreens: false,
      viewPanel: 'results',
      activeGrouping: dflt,
    })
  }

  componentWillMount() {
    // search with no limits
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.searchFunds(this.state, true)
    if (!this.props.cart) {
      this.props.cartChange()
    }
  }

  componentDidMount() {
    this.props.tutorialdismissChange(this.props.tutorialdismiss || false)
  }

  componentWillReceiveProps(props) {
    // did the location change? trigger a new search
    if (props.location !== this.state.location) {
      const state = Object.assign(this.state, stateFromProps(props))
      // set state
      this.setState(state)
      // update the screen
      // this.selectScreen(state.screen)
      // search again
      this.searchFunds(state)
    // has results, new result, and orderby (not the home page)
    } else if (
      props.result &&
      props.result.results &&
      props.result.orderBy &&
      this.state.lastResult !== props.result.results
    ){
      // setting results from query
      // update the screen
      // const state = Object.assign(this.state, stateFromProps(props))
      // this.selectScreen(state.screen)
      this.setState({
        lastResult:props.result.results,
        funds: this.state.funds.concat(props.result.results)
      })
    }
  }


  /*
   * CALLING THE API
   *
   */
  searchFunds = (state, noLimit) => {
    this.props.searchFunds(
      state.searchQuery,
      state.page,
      state.sort,
      this.whereSearch(state),
      state.isDesc,
      noLimit
    )
  }

  whereSearch = (state) => {
    /*
      returns array of where conditions based on
      state.selectedFilters
     */
    const keys =  Object.keys(state.selectedFilters)

    const where = keys.map((filter) => {
      let name = filter
      const selectedFilter = state.selectedFilters[filter]

      if (!selectedFilter) {
        return null
      }

      // console.log('filter:',filter,selectedFilter )
      let value = selectedFilter // .value

      switch (filter) {
        case 'fundFamily':
          name = 'fund_family_name'
          break
        case 'currency':
          name = 'currency_name'
          break
        case 'sri':
          name = 'ussif'
          break
        case 'fundUssif':
          name = 'ussif'
          break
        case 'type':
          name = 'legal_type'
          break
        case 'diversified':
          name = 'non_diversified_fund'
          break
        case 'targetDate':
          name = 'is_target_date'
          break
        case 'fundPerformance':
          name = value
          value = 0
          break
        case 'fundCategory':
          name = 'category_group'
          break
        case 'fundGroup':
          name = 'category_group'
          break
        // GFF
        case 'clean':
          // isClean = true
          name = 'wff_civ_count'
          value = 0
          break
        case 'fffGrade':
          name = 'grade_fossil'
          break
        case 'ffbGrade':
          name = 'grade_fossil_bank'
          break
        case 'ffiGrade':
          name = 'grade_fossil_insure'
          break
        case 'dffGrade':
          name = 'grade_deforestation'
          break
        case 'gefGrade':
          name = 'grade_gender_equality'
          break
        case 'deiGrade':
          name = 'grade_dei'
          break
        case 'rjiGrade':
          name = 'grade_rji'
          break
        case 'hrcGrade':
          name = 'grade_hrc'
          break
        case 'wffGrade':
          name = 'grade_military'
          break
        case 'gffGrade':
          name = 'grade_guns'
          break
        case 'pffGrade':
          name = 'grade_prison_industrial_complex'
          break
        case 'tffGrade':
          name = 'grade_tobacco'
          break
        default:
          break
      }

      // console.log('value:',value,selectedFilter )
      if (selectedFilter.label === DefaultFilter) {
        return null
      }

      if (filter === 'fundPerformance') {
        return { name: name, op: 'gt', value: value }
      }
      if (
        filter === 'fffGrade' ||
        filter === 'ffbGrade' ||
        filter === 'ffiGrade' ||
        filter === 'dffGrade' ||
        filter === 'gefGrade' ||
        filter === 'deiGrade' ||
        filter === 'rjiGrade' ||
        filter === 'hrcGrade' ||
        filter === 'wffGrade' ||
        filter === 'gffGrade' ||
        filter === 'pffGrade' ||
        filter === 'tffGrade'
      ) {
        return { name: name, op: 'lte', value: parseFloat(value) || 0 }
      }

      if (
        filter === 'sri' ||
        filter === 'fundUssif'
      ) {
        return { name: name, op: 'gte', value: parseFloat(value) || 0 }
      }

      return { name: name, op: 'eq', value: value }
    })

    return where
  }


  /*
   * MANAGING FILTERS
   *
   */
  selectFilter = (name) => {
    return (val) => {
      const valValue = val.value || val
      const selectedFilters = Object.assign({}, this.state.selectedFilters)

      if (name === 'market' && val) {
        Object.keys(selectedFilters)
          .filter((filterName) => {
            // if the value is not in options set to default
            // this occurs because of dynamic options based on market
            const value = selectedFilters[filterName]
            // radio options are strings, dropdowns are objects
            const options = this.filterOptions(filterName, valValue)

            // console.log('option:',value, options )
            return !value ||
              !options.find((option) => value.value === option.value)
          })
          .forEach((v) => delete selectedFilters[v])
      }
      selectedFilters[name] = (!val || valValue === DefaultFilter) ?
        (null) :
        valValue
      this.context.router.push({
        pathname: config.routes.list,
        query: propsFromState(Object.assign(
          this.state,
          { selectedFilters: selectedFilters, page:1 }
        ))
      })
    }
  }

  removeSearchFilter = () => {
    this.context.router.push({
      pathname: config.routes.list,
      query: propsFromState(
        Object.assign(this.state, { searchQuery: '', page: 1 })
      )
    })
  }

  removeFilters = () => {
    const state = {
      page: 1,
      searchQuery: '',
      selectedFilters: {}
    }

    // this.setState(state)
    this.context.router.push({
      pathname: config.routes.list,
      query: propsFromState(Object.assign(this.state, state))
    })
  }

  removeFilter = (prop) => {
    return () => {
      const selectedFilters = Object.assign({}, this.state.selectedFilters)
      delete selectedFilters[prop]
      this.context.router.push({
        pathname: config.routes.list,
        query: propsFromState(Object.assign(
          this.state,
          { page: 1, selectedFilters: selectedFilters }
        ))
      })
    }
  }

  filterOptions = (name, marketValue) => {
    const foundOption = MarketOptionsFilters.find(
      (option) => { return name === option }
    )
    const optionsName = foundOption ?
      this.marketOptions(name, marketValue) :
      name

    // console.log(config.formOptions)
    return config.formOptions[optionsName].map(
      (option) => {
        return {
          label: option.name,
          value: option.value || option.name
        }
      }
    )
  }

  marketOptions = (optionPrefix, marketValue) => {
    /*
      Get the market specific version of options if market is selected
     */
    if (marketValue) {
      return optionPrefix + marketValue
    }

    if (
      this.state.selectedFilters.market &&
      this.state.selectedFilters.market !== DefaultFilter
    ) {
      return optionPrefix + this.state.selectedFilters.market
    }

    return optionPrefix + 'All'
  }

  resetCart = () => {
    this.props.cartChange([], {})
  }


  /*
   * ON CLICKS + INPUTS
   *
   */
  clickPrevTutorial = () => {
    const prevTutorialId = this.state.currentTutorial - 1
    if (prevTutorialId >= 0) {
      this.setState({
        currentTutorial: prevTutorialId,
        showFilters: prevTutorialId === 2,
      })
    }
  }

  clickNextTutorial = () => {
    const nextTutorialId = this.state.currentTutorial + 1
    this.setState({
      currentTutorial: nextTutorialId,
      showFilters: nextTutorialId === 2,
    })
  }

  clickCloseTutorial = () => {
    if (this.state.showTutorial) {
      this.props.tutorialdismissChange(true)
      this.setState({
        showTutorial: false,
        currentTutorial: -1
      })
    }
  }

  clickTutorialRestart = () => {
    this.setState({
      showTutorial: true,
      currentTutorial: 0,
    })
  }

  clickSearch = () => {
    this.context.router.push({
      pathname: config.routes.list,
      query: propsFromState(Object.assign(this.state, {
        page: 1, searchQuery: this.state.searchInput || ''
      }))
    })
  }

  clickToggleFilters = () =>{
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  clickColumnHeader = (prop, asc=null) => {
    return () => {
      let isDesc = null
      if (asc) {
        isDesc = asc === 'desc'
      } else {
        isDesc = prop === this.state.sort ?
          !this.state.isDesc :
          true
      }

      scroller.scrollTo('table-top', {
        duration: 100,
        // delay: 100,
        smooth: true,
        // containerId: 'ContainerElementID',
        offset: 50, // Scrolls to element + 50 pixels down the page
        // ... other options
      });

      this.context.router.push({
        pathname: config.routes.list,
        query: propsFromState(Object.assign(this.state, {
          sort: prop,
          isDesc: isDesc,
          page:1}))
      })
    }
  }

  clickCompareSelect = (shareclass) => {
    this.props.cartChange(this.props.cart.results, shareclass)
  }

  clickShareclass = (shareclass, page=null) => {
    const { ticker, fund_legal_name, fund_id,
            investment_vehicle_id } = shareclass

    // make ticker safe for URL
    const sTicker = ticker || 'N'

    const urlBuilder = (route, profilePath) => {
      return route + '/' +
        format.sanitize(fund_legal_name) + '/' +
        sTicker + '/' +
        profilePath + '/' +
        fund_id + '/' +
        investment_vehicle_id
    }

    const url = urlBuilder(config.routes.fund, page || config.profilePath)

    // return a function that when called navigates to this URL
    return () => {
      this.context.router.push(url)
    }
  }

  clickGetMoreFunds = () =>{
    this.context.router.push({
      pathname: config.routes.list,
      query: propsFromState(
        Object.assign(this.state, { page: this.state.page + 1 })
      )
    })
  }

  setViewPanel = (v) => {
    this.setState({viewPanel: v})
  }

  getCompareSelectStyles = (cart, investment_vehicle_id) => {
    let inCart = false
    let allFull = true
    if (
      cart &&
      cart.results &&
      cart.results.length
    ) {
      for (let i = 0; i < cart.results.length; i++) {
        // if we find an N we are not all full
        if (cart.results[i].id === 'N') {
          allFull = false
        }
        // if we find a match we are in cart
        if (
          cart.results[i].id === investment_vehicle_id
        ) {
          inCart = true
        }
      }
    }

    const className = inCart ?
      'fa fa-check-square-o fa-2x' :
      'fa fa-square-o fa-2x'

    const styleName = !inCart && allFull ? 'disabled' : ''

    return { className, styleName }
  }


  /*
   * TEXT INPUT
   *
   */

  onSearchInputChange = (event) => {
    this.setState({ searchInput: event.target.value })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.clickSearch()
    }
  }

  /**
   * Update state with new active grouping, to be used in displaying
   * percentile ranks and color sliders, and controlled by a form control.
   * Changing form control calls changeActiveGrouping() with the newly
   * selected grouping.
   *
   * @param  {String} newGrouping - Either 'rank', 'peer', or 'group'
   */
  changeActiveGrouping = (newGrouping) =>{
    if ((typeof newGrouping === 'string') &&
        (newGrouping !== this.state.activeGrouping) &&
          (newGrouping==='rank' ||
           newGrouping==='peer' ||
           newGrouping==='group')) {
      // set state
      this.setState({
        activeGrouping: newGrouping
      })

      // switch prop for header based on new grouping
      let prop = ''
      switch (newGrouping) {
        case 'rank':
          prop = 'gef_rank'
          break
        case 'peer':
          prop = 'gef_peer_norm'
          break
        case 'group':
          prop = 'gef_grp_norm'
          break
      }

      // clickColumnHeader returns a function using the prop; call it
      this.clickColumnHeader(prop)()
    }
  }


  /*
   * MAIN RENDER
   *
   */
  render() {
    // if there's an error with the API results, go to 404 page
    if (
      this.props.result &&
      this.props.result.results &&
      this.props.result.results.error
    ){
      this.context.router.push(config.routes.notFound)
      return <div styleName='main'>
        <Loader
          options={{scale: 0.70, top:'2.0rem'}}
          loaded={false}
        />
      </div>
    }

    return (
      <div styleName='main'>
        {
          container.helmet(
            'Search funds',
            config.app.description,
            config.domain + config.routes.clean
          )
        }

        { /* defined above */ }
        <IyvListHeaderTitle />

        <ContainerDivs>

          { /* core/IyvListSearchBar/IyvListSearchBar */ }
          <IyvListSearchBar
            currentTutorial={this.state.currentTutorial}
            showTutorial={this.state.showTutorial}
            clickCloseTutorial={this.clickCloseTutorial}
            onSearchInputChange={this.onSearchInputChange}
            searchInput={this.state.searchInput}
            handleKeyPress={this.handleKeyPress}
            clickSearch={this.clickSearch}
          />

          { /* core/IyvListTutorial/IyvListTutorial */ }
          <IyvListTutorial
            showTutorial={this.state.showTutorial}
            currentTutorial={this.state.currentTutorial}
            clickPrevTutorial={this.clickPrevTutorial}
            clickNextTutorial={this.clickNextTutorial}
            clickCloseTutorial={this.clickCloseTutorial}
          />

          { /* core/IyvListFilters/IyvListSearchSettingsButton */ }
          <IyvListSearchSettingsButton
            currentTutorial={this.state.currentTutorial}
            showTutorial={this.state.showTutorial}
            clickCloseTutorial={this.clickCloseTutorial}
            clickToggleFilters={this.clickToggleFilters}
            showFilters={this.state.showFilters}
          />

          { /* core/IyvListFilters/IyvListFilters */ }
          <IyvListFilters
            activeGrouping={this.state.activeGrouping}
            showFilters={this.state.showFilters}
            currentTutorial={this.state.currentTutorial}
            showTutorial={this.state.showTutorial}
            clickCloseTutorial={this.clickCloseTutorial}
            changeActiveGrouping={this.changeActiveGrouping}
            selectFilter={this.selectFilter}
            filterOptions={this.filterOptions}
            selectedFilters={this.state.selectedFilters}
            defaultFilter={DefaultFilter}
            filters={Filters}
          />

        </ContainerDivs>

        <Element name='table-top' />

        <div styleName='table-wrapper'>
          <div styleName='wrap-tutorial-restart-active-filters'>

            { /* core/IyvListTutorial/IyvListTutorialRestartButton */ }
            <IyvListTutorialRestartButton
              clickTutorialRestart={this.clickTutorialRestart}
            />

            { /* core/IyvListFilters/IyvListActiveFilters */ }
            <IyvListActiveFilters
              searchQuery={this.state.searchQuery}
              removeFilter={this.removeFilter}
              removeFilters={this.removeFilters}
              removeSearchFilter={this.removeSearchFilter}
              selectedFilters={this.state.selectedFilters}
              filterOptions={this.filterOptions}
              defaultFilter={DefaultFilter}
            />

          </div>

          <IyvListTableMobileWraps
            loading={this.props.loading}
            cart={this.props.cart}
            page={this.state.page}
            currentTutorial={this.state.currentTutorial}
            showTutorial={this.state.showTutorial}
            viewPanel={this.state.viewPanel}
            funds={this.state.funds}
            lastResult={this.state.lastResult}
            sort={this.state.sort}
            isDesc={this.state.isDesc}
            activeGrouping={this.state.activeGrouping}
            clickCloseTutorial={this.clickCloseTutorial}
            clickShareclass={this.clickShareclass}
            clickCompareSelect={this.clickCompareSelect}
            clickColumnHeader={this.clickColumnHeader}
            removeFilters={this.removeFilters}
            clickGetMoreFunds={this.clickGetMoreFunds}
            setViewPanel={this.setViewPanel}
            getCompareSelectStyles={this.getCompareSelectStyles}
            resultsTableColumns={ResultsTableColumns}
          />

          { /* core/IyvListCart/IyvListCart */ }
          <IyvListCart
            cart={this.props.cart}
            resetCart={this.resetCart}
            cartChange={this.props.cartChange}
            clickCompareSelect={this.clickCompareSelect}
          />

        </div>
      </div>
    )
  }
}
